var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.04 4.36c.78.77 1.31.24 1.31.24l.98.98a.8.8 0 0 1 0 1.13l-7.22 7.22a.8.8 0 0 1-1.13 0L5 12.95s.53-.53-.24-1.3c-.78-.78-1.31-.25-1.31-.25l-.98-.98a.8.8 0 0 1 0-1.13l7.22-7.22a.8.8 0 0 1 1.13 0l.98.98s-.53.54.24 1.3Zm-6.08 8.36-.01.05.6.6.95-.96L4 8.9l-.96.96.6.6.05-.02c.53-.08 1.11.1 1.64.64.54.53.72 1.1.64 1.64Zm-1.4-4.39 3.5 3.52 5.7-5.7-.59-.6h-.05c-.53.1-1.11-.1-1.64-.63-.54-.53-.72-1.1-.64-1.64l.01-.05-.6-.6-5.7 5.7Zm1.87-.2 3.48-3.49.53.52-3.49 3.48-.52-.52Zm4.7-2.27L7.65 9.34l.52.52 3.49-3.48-.53-.52Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.ad7a8c6e0322ce200c85804f9cd84894.svg";
export { ForwardRef as ReactComponent };